import * as React from "react";
import { Upload } from "antd";
import { UploadProps } from "antd/lib/upload";
import { API } from "General/API";

interface BaseUploadProps extends UploadProps {
  children: React.ReactNode;
}

export const BaseUpload = (props: BaseUploadProps) => {
  const headers = API.headersObject();
  return <Upload {...props} headers={headers} />;
};
